import React from "react";

import styles from "./menu-nav-bar-space.module.less";

export function MenuNavBarSpace(props) {
  const { children } = props;
  return <div className={styles["menu-nav-bar-space"]}>{children}</div>;
}
